import styled from 'styled-components';
import IconNotice from '../IconNotice';

const IconVote = styled(IconNotice)`
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.5);
`;

export default IconVote;
